import * as React from 'react';
import { useState } from 'react';
import { Typography } from '@execonline-inc/execonline-ui';
import { RationaleItem } from '../../DashboardSummaryStore/Types';
import ChevronDown from '../Cutesies/ChevronDown';
import ChevronUp from '../Cutesies/ChevronUp';
import { T } from '../../Translations';

interface Props {
  items: RationaleItem[];
}

const AIRationale: React.FC<Props> = ({ items }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasItems = items.length > 0;

  return (
    <div>
      {/* Expandable header */}
      <button
        onClick={() => hasItems && setIsExpanded(!isExpanded)}
        className={`flex items-center space-x-2 text-sm transition-colors w-full ${
          hasItems
            ? 'text-gray-600 hover:text-gray-800 cursor-pointer'
            : 'text-gray-400 cursor-default'
        }`}
        disabled={!hasItems}
        data-intercom-target="ai-summary-rationale-toggle"
      >
        {isExpanded ? (
          <ChevronUp className="w-4 h-4" color="currentColor" />
        ) : (
          <ChevronDown className="w-4 h-4" color="currentColor" />
        )}
        <span className="font-medium">
          <T kind="AI Rationale" />
        </span>
        {!hasItems && (
          <span className="text-gray-400 text-xs ml-2">
            <T kind="(No data available)" />
          </span>
        )}
      </button>

      {/* Rationale items */}
      {isExpanded && hasItems && (
        <div className="mt-3 space-y-4 pl-6 border-l-2 border-gray-200">
          {items.map((item, index) => (
            <div key={index} className="space-y-1">
              <Typography variant="bodyMedium" className="text-gray-700 italic">
                "{item.quote}"
              </Typography>
              <Typography variant="caption" className="text-gray-500">
                <T kind="Source:" /> {item.source}
              </Typography>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AIRationale;
